import { IProduct } from '../../../IProduct';
import { P00039DataRxTxIndex } from '../../P00039Sync';
import { Pool } from '../../../../../../apis/pool.api';

export function P00062InstallationReset(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  editValue(
    P00039DataRxTxIndex.PACPOLY_Controle,
    'ppCResetUsine',
    1,
    null,
    productClass,
  );
}
